import React from 'react';
import { useTranslation } from 'react-i18next';
import './TeamModals.scss';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
};

const ConfirmRemoveModal: React.FC<Props> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();

    if (!open) return null;

    return (
        <div className="modalOverlay">
            <div className="modal">
                <h2>{t('pages.team.removeUser.title')}</h2>
                <p>{t('pages.team.removeUser.description')}</p>

                <div className="modalActions">
                    <button className="button button-secondary" onClick={onClose}>
                        {t('pages.common.cancel')}
                    </button>
                    <button
                        className="button button-danger"
                        onClick={async () => {
                            await onConfirm();
                            onClose();
                        }}
                    >
                        {t('pages.common.remove')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmRemoveModal;
